export const GET_CONTENT_BY_SESSION = 'GET_CONTENT_BY_SESSION';
export const SET_CONTENT_BY_SESSION = 'SET_CONTENT_BY_SESSION';
export const SET_CONTENT_LOADING = 'SET_CONTENT_LOADING';
